// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

import Navbar from "./navbar";
import Header from "./customstyle/header";

// Map components
import StateMapComponent from "components/Map/StateMapComponent"

function Overview({url, year}) {
  return (
    <DashboardLayout>
      <Navbar year={year}/>
      <MDBox mb={2} />
      <Header>
        <MDBox pt={2} px={2} lineHeight={1.25}>
          <MDBox mb={1}>
            <StateMapComponent downloadUrl={url}/>
          </MDBox>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;